import React from "react";
import get from "lodash/get";
import { withTranslation } from "react-i18next";
import Modal from "../modal-new";
import ImageUploadInput from "../inputs/image-upload";
import TagInput from "../inputs/tag-input";
import Select from "../inputs/select";
import submit from "submit-form";
import getCycleCardImagePath from "../../utils/get-cycle-card-image-path";
import SvgIcon from "../SvgIcon";
import { RillContext } from "../../rill/RillReact/share/base";
import moment from "moment";
import DateInput from "../inputs/date-input";
import ToolTip from "../tooltip";
import {
  isPushActiveCoach,
  isPullActiveCoach,
} from "../../utils/user-helpers";
import { isValidVideoLink } from "../../utils/string-helpers";

class AddCycleModal extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      name: "",
      experience: 2,
      tags: [],
      numberOfWeeks: 4,
      sessionsPerWeek: 1,
      description: "",
      submitted: false,
      video: "",
      firstDayOfWeek: 1,
      startDate: moment().day(8).toDate(),
      status: "draft",
      trainingSplitType: "suggested",
      hideFromPush: false,
      folderId: "",
    };
    this.state = this.initialState;
    this.pushTag = this.pushTag.bind(this);
    this.removeTag = this.removeTag.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { editCycle, workoutFolders = [], query } = this.context.locals;
    const storeType = query.storeType;
    if (editCycle) {
      const {
        name,
        goals = [],
        difficulty = "Intermediate",
        numberOfWeeks = storeType !== "single-workot" ? 4 : 1,
        sessionsPerWeek = 1,
        description,
        video,
        firstDayOfWeek,
        status,
        trainingSplitType,
        hideFromPush,
      } = editCycle;

      const currentFolder = workoutFolders.find((f) =>
        (f.workoutIds || []).some((id) => String(id) === String(editCycle._id))
      );

      this.setState({
        name,
        experience: { Beginner: 1, Intermediate: 2, Expert: 3 }[difficulty],
        tags: goals,
        numberOfWeeks,
        sessionsPerWeek,
        description,
        video,
        firstDayOfWeek,
        startDate: moment(
          editCycle.programs[0]?.startDate,
          "YYYYMMDD"
        ).toDate(),
        status,
        trainingSplitType: trainingSplitType || "suggested",
        hideFromPush: hideFromPush || false,
        folderId: currentFolder ? String(currentFolder._id) : "",
      });
    } else {
      this.setState({ folderId: query.folderId || "" });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextContext.locals.query.submitError) {
      this.setState({ submitted: false });
    }
  }

  handleCycleTypeChange() {
    document.getElementById("add-cycle-form").reset();
  }

  handleSubmit(e) {
    if (this.state.submitted) {
      // Needed for avoid form submit on pressing enter when creating a new tag
      e.preventDefault();
      return;
    }

    const editCycle = this.context.locals.editCycle;
    const previousSplit = editCycle?.trainingSplitType || "suggested";
    const nextSplit = this.state.trainingSplitType || "suggested";
    const enablingForcedOnPublished =
      editCycle &&
      editCycle.status === "published" &&
      previousSplit === "suggested" &&
      nextSplit === "forced";

    // if (
    //   enablingForcedOnPublished &&
    //   typeof window !== "undefined" &&
    //   !window.confirm(
    //     "Existing members' scheduled workouts may be overwritten. Continue?"
    //   )
    // ) {
    //   e.preventDefault();
    //   return;
    // }

    const storeType = this.context.locals.query.storeType || "programs";
    const isPrograms = storeType === "programs";
    if (isPrograms && this.state.video && !isValidVideoLink(this.state.video)) {
      e.preventDefault();
      alert("Please enter a valid YouTube or Loom URL for the intro video.");
      return;
    }

    this.setState({ submitted: true });
  }

  pushTag(tag) {
    this.setState({ tags: [...this.state.tags, tag] });
  }

  removeTag(idx) {
    const tags = this.state.tags;
    tags.splice(idx, 1);
    this.setState({ tags });
  }

  handleChange({ target }) {
    const { value } = target;
    const strings = ["name", "description", "video", "startDate", "folderId"];
    this.setState({
      [target.name]: strings.includes(target.name) ? value : parseInt(value),
    });
  }

  render() {
    const { t } = this.props;
    const {
      locals: {
        activeUserToRequest,
        query,
        editCycle,
        athlete,
        flash,
        workoutFolders = [],
      },
    } = this.context;
    const {
      name,
      tags,
      experience,
      numberOfWeeks,
      sessionsPerWeek,
      description,
      video,
      firstDayOfWeek,
      startDate,
      status,
      trainingSplitType,
      hideFromPush,
      folderId,
    } = this.state;
    const isCoachingPortal = Boolean(
      this.context.locals.pathname.includes("coaching-portal")
    );
    const [firstName, lastName] = get(activeUserToRequest, "name", "").split(
      / +/
    );

    const storeType = query.storeType || "programs";
    const isSingleWorkout = storeType === "single-workout";
    const isTeams = storeType === "teams";
    const isPrograms = !isSingleWorkout && !isTeams;

    const coachHasPush =
      isPushActiveCoach(activeUserToRequest) &&
      !!activeUserToRequest.pushAccountInfo;
    const coachHasPull = isPullActiveCoach(activeUserToRequest);
    const canHideFromPush = isTeams && coachHasPush && coachHasPull;

    const prefixKeyForNonTemplates = {
      programs: "prefixProgram",
      teams: "prefixTeam",
      "single-workout": "prefixSingleWorkout",
    };
    const prefixKey = query.isTemplate
      ? "prefixTemplate"
      : prefixKeyForNonTemplates[storeType];
    const prefix = t(`addCycle.${prefixKey}`);
    const prefixLowerKey = query.isTemplate
      ? "prefixTemplateLower"
      : `${prefixKeyForNonTemplates[storeType]}Lower`;

    let organizationQuery = ``;

    if (this.context.locals.query.organizationCoach) {
      organizationQuery = `&organizationCoach=${this.context.locals.query.organizationCoach}`;
    }

    const endpoint = editCycle
      ? `/actions/cycle/edit/${editCycle._id}?athlete=${
          athlete && athlete._id
        }&coaching=${isCoachingPortal}`
      : `/actions/cycle?proxyAthlete=${query.athlete || ""}&${
          query.isSubscription
            ? `isSubscription=true`
            : `isTemplate=${query.isTemplate}` + organizationQuery
        }&storeType=${storeType}${query.fromTemplate ? `&fromTemplate=true` : ""}`;

    return (
      <form
        id="add-cycle-form"
        action={endpoint}
        method="POST"
        encType="multipart/form-data"
        data-noreset
        onSubmit={this.handleSubmit}
      >
        {editCycle ? (
          <div>
            <input type="hidden" name="_id" defaultValue={editCycle._id} />
            <input
              type="hidden"
              name="tags"
              defaultValue={JSON.stringify(tags)}
            />
          </div>
        ) : (
          <div>
            <input
              type="hidden"
              name="tags"
              defaultValue={JSON.stringify(tags)}
            />
          </div>
        )}
        <Modal
          className="add-cycle-modal"
          title={t(editCycle ? "addCycle.titleEdit" : "addCycle.titleNew", {
            prefix,
            context: prefixKey,
          })}
          toClear={["isSubscription", "cycleType", "storeType", "cycleId"]}
        >
          <div className="body">
            {isSingleWorkout && (
              <div className="row">
                <div className="group max-w-full! mb-0!">
                  <label>{t("addCycle.nameLabel", { prefix })}</label>
                  <input
                    name="name"
                    className="text-input"
                    placeholder={t("addCycle.namePlaceholder", {
                      prefix: prefixLowerKey
                        ? t(`addCycle.${prefixLowerKey}`)
                        : prefix,
                    })}
                    value={name}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            )}

            {!isSingleWorkout && (
              <div className={`row ${isTeams ? "mb-2!" : ""}`}>
                <div className="left">
                  <div className={`group ${isTeams ? "mb-0!" : ""}`}>
                    <label>{t("addCycle.nameLabel", { prefix })}</label>
                    <input
                      name="name"
                      className="text-input"
                      placeholder={t("addCycle.namePlaceholder", {
                        prefix: prefixLowerKey
                          ? t(`addCycle.${prefixLowerKey}`)
                          : prefix,
                      })}
                      value={name}
                      onChange={this.handleChange}
                    />
                  </div>

                  {!isTeams && (
                    <div className="group">
                      <label>{t("addCycle.numberOfWeeksPerBlock")}</label>

                      <Select
                        name="numberOfWeeks"
                        value={numberOfWeeks}
                        onChange={(val) =>
                          this.handleChange({
                            target: { name: "numberOfWeeks", value: val },
                          })
                        }
                        options={[
                          {
                            text: t("addCycle.weekCount", { count: 1 }),
                            value: 1,
                          },
                          {
                            text: t("addCycle.weekCount", { count: 2 }),
                            value: 2,
                          },
                          {
                            text: t("addCycle.weekCount", { count: 3 }),
                            value: 3,
                          },
                          {
                            text: t("addCycle.weekCount", { count: 4 }),
                            value: 4,
                          },
                          {
                            text: t("addCycle.weekCount", { count: 5 }),
                            value: 5,
                          },
                          {
                            text: t("addCycle.weekCount", { count: 6 }),
                            value: 6,
                          },
                          {
                            text: t("addCycle.weekCount", { count: 7 }),
                            value: 7,
                          },
                          {
                            text: t("addCycle.weekCount", { count: 8 }),
                            value: 8,
                          },
                        ]}
                      />
                    </div>
                  )}
                </div>

                {isTeams && (
                  <div className="group">
                    <label>{t("addCycle.introVideo")}</label>

                    <div className="input-container relative">
                      <SvgIcon
                        src="/img/new-icons/link.svg"
                        classNames="absolute left-3 top-3"
                        noFilterOnLight={true}
                      />
                      <input
                        type="text"
                        value={video}
                        placeholder={t("addCycle.videoPlaceholderLoom")}
                        name="video"
                        className="pl-10! pr-10! mt-0!"
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                )}

                {!isTeams && (
                  <div className="group">
                    <label>{t("addCycle.tags")}</label>
                    <TagInput
                      tags={tags}
                      pushTag={this.pushTag}
                      removeTag={this.removeTag}
                    />
                  </div>
                )}
              </div>
            )}

            {isTeams && (
              <div className="teams-add-cycle-row">
                <div className="group w-1/3">
                  <label className="h-6 mb-1! flex! items-center">
                    {t("addCycle.sessionsPerWeek")}
                  </label>
                  <Select
                    name="sessionsPerWeek"
                    value={sessionsPerWeek}
                    onChange={(val) =>
                      this.handleChange({
                        target: { name: "sessionsPerWeek", value: val },
                      })
                    }
                    options={[
                      {
                        text: t("addCycle.sessionCount", { count: 1 }),
                        value: 1,
                      },
                      {
                        text: t("addCycle.sessionCount", { count: 2 }),
                        value: 2,
                      },
                      {
                        text: t("addCycle.sessionCount", { count: 3 }),
                        value: 3,
                      },
                      {
                        text: t("addCycle.sessionCount", { count: 4 }),
                        value: 4,
                      },
                      {
                        text: t("addCycle.sessionCount", { count: 5 }),
                        value: 5,
                      },
                      {
                        text: t("addCycle.sessionCount", { count: 6 }),
                        value: 6,
                      },
                      {
                        text: t("addCycle.sessionCount", { count: 7 }),
                        value: 7,
                      },
                    ]}
                  />
                </div>

                <div className="group w-1/3">
                  <div className="flex flex-row items-center gap-1 mb-1">
                    <label className="mb-0!">
                      {t("addCycle.firstDayOfWeek")}
                    </label>
                    <ToolTip
                      body={t("addCycle.firstDayOfWeekTooltip")}
                      id="team-first-day-info"
                    >
                      <SvgIcon
                        alt={t("addCycle.infoIconAlt")}
                        src="/img/new-icons/question-circle.svg"
                      />
                    </ToolTip>
                  </div>

                  <Select
                    name="firstDayOfWeek"
                    value={firstDayOfWeek}
                    onChange={(val) =>
                      this.handleChange({
                        target: { name: "firstDayOfWeek", value: val },
                      })
                    }
                    disabled={true}
                    options={[
                      { text: t("addCycle.monday"), value: 1 },
                      { text: t("addCycle.tuesday"), value: 2 },
                      { text: t("addCycle.wednesday"), value: 3 },
                      { text: t("addCycle.thursday"), value: 4 },
                      { text: t("addCycle.friday"), value: 5 },
                      { text: t("addCycle.saturday"), value: 6 },
                      { text: t("addCycle.sunday"), value: 0 },
                    ]}
                  />
                </div>

                <div className="group w-1/3">
                  <label
                    label
                    className="h-6 mb-1! label req flex! items-center"
                    htmlFor="startDate"
                  >
                    {t("addCycle.startDate")}
                  </label>
                  <DateInput
                    name="startDate"
                    placeholder={t("addCycle.startDatePlaceholder")}
                    value={startDate}
                    onChange={(date) => {
                      const startDate = moment(date).toDate();
                      const dayOfWeek = moment(date).day();
                      this.handleChange({
                        target: { name: "startDate", value: startDate },
                      });
                      this.handleChange({
                        target: { name: "firstDayOfWeek", value: dayOfWeek },
                      });
                    }}
                    isDisabled={!!editCycle}
                  />
                </div>
              </div>
            )}

            {!isSingleWorkout && !isTeams && (
              <div className="row">
                <div className="group">
                  <label>{t("addCycle.sessionsPerWeek")}</label>
                  <Select
                    name="sessionsPerWeek"
                    value={sessionsPerWeek}
                    onChange={(val) =>
                      this.handleChange({
                        target: { name: "sessionsPerWeek", value: val },
                      })
                    }
                    options={[
                      {
                        text: t("addCycle.sessionCount", { count: 1 }),
                        value: 1,
                      },
                      {
                        text: t("addCycle.sessionCount", { count: 2 }),
                        value: 2,
                      },
                      {
                        text: t("addCycle.sessionCount", { count: 3 }),
                        value: 3,
                      },
                      {
                        text: t("addCycle.sessionCount", { count: 4 }),
                        value: 4,
                      },
                      {
                        text: t("addCycle.sessionCount", { count: 5 }),
                        value: 5,
                      },
                      {
                        text: t("addCycle.sessionCount", { count: 6 }),
                        value: 6,
                      },
                      {
                        text: t("addCycle.sessionCount", { count: 7 }),
                        value: 7,
                      },
                    ]}
                  />
                </div>

                <ExperienceLevel
                  experience={experience}
                  setState={(toset) => this.setState(toset)}
                  t={t}
                />
              </div>
            )}
            {isPrograms && (
              <div className="row">
                <div className="group">
                  <label htmlFor="program-intro-video">
                    {t("addCycle.programIntroVideo")}
                  </label>
                  <div className="input-container relative">
                    <SvgIcon
                      src="/img/new-icons/link.svg"
                      classNames="absolute left-3 top-3"
                      noFilterOnLight={true}
                    />
                    <input
                      id="program-intro-video"
                      type="text"
                      value={video || ""}
                      placeholder={t("addCycle.videoPlaceholderLoom")}
                      name="video"
                      className="pl-10! pr-10! mt-0!"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
            )}

            {!isSingleWorkout && !isTeams && (
              <div className="row">
                <div className="group description-group mt-0!">
                  <label>{t("addCycle.description")}</label>
                  <textarea
                    name="description"
                    className="textarea-input"
                    placeholder={t("addCycle.descriptionPlaceholder")}
                    value={description}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="group">
                  <ImageUploadInput
                    name="image"
                    className="program-image"
                    prefix={prefix}
                    defaultValue={
                      editCycle ? getCycleCardImagePath(editCycle) : ""
                    }
                    raw
                  />
                </div>
              </div>
            )}

            {isTeams && (
              <div className="single-workout-section">
                <div className="single-workout-group">
                  <ExperienceLevel
                    experience={experience}
                    setState={(toset) => this.setState(toset)}
                    t={t}
                  />

                  <div className="group description-group">
                    <label>{t("addCycle.description")}</label>
                    <textarea
                      name="description"
                      className="textarea-input"
                      placeholder={t("addCycle.descriptionPlaceholder")}
                      value={description}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="group">
                  <ImageUploadInput
                    name="image"
                    className="program-image"
                    prefix={prefix}
                    defaultValue={
                      editCycle ? getCycleCardImagePath(editCycle) : ""
                    }
                    raw
                  />
                </div>
              </div>
            )}

            {isSingleWorkout && (
              <div className="single-workout-section">
                <div className="single-workout-group">
                  <div className="group description-group mt-0! grow-0!">
                    <label>{t("addCycle.description")}</label>
                    <textarea
                      name="description"
                      className="textarea-input"
                      placeholder={t("addCycle.descriptionPlaceholder")}
                      value={description}
                      onChange={this.handleChange}
                    />
                  </div>

                  <ExperienceLevel
                    experience={experience}
                    setState={(toset) => this.setState(toset)}
                    t={t}
                  />

                  {workoutFolders.length > 0 && (
                    <div className="group">
                      <label>{t("addCycle.folderLabel")}</label>
                      <Select
                        name="folderId"
                        value={folderId}
                        onChange={(val) =>
                          this.handleChange({
                            target: { name: "folderId", value: val },
                          })
                        }
                        options={[
                          { text: t("addCycle.folderUncategorized"), value: "" },
                          ...workoutFolders.map((f) => ({
                            text: f.name,
                            value: String(f._id),
                          })),
                        ]}
                        overlay={true}
                      />
                    </div>
                  )}
                </div>

                <div className="single-workout-group">
                  <div className="group">
                    <label>{t("addCycle.introVideo")}</label>

                    <div className="input-container relative">
                      <SvgIcon
                        src="/img/new-icons/link.svg"
                        classNames="absolute left-3 top-3"
                        noFilterOnLight={true}
                      />
                      <input
                        type="text"
                        value={video}
                        placeholder={t("addCycle.videoPlaceholderYoutube")}
                        name="video"
                        className="pl-10! pr-10! mt-0!"
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>

                  <div className="group">
                    <ImageUploadInput
                      name="image"
                      className="program-image"
                      prefix={prefix}
                      defaultValue={
                        editCycle ? getCycleCardImagePath(editCycle) : ""
                      }
                      raw
                    />
                  </div>
                </div>
              </div>
            )}

            {isTeams && (
              <div className="training-split-section mt-4!">
                <input
                  type="hidden"
                  name="trainingSplitType"
                  value={trainingSplitType}
                />
                <div className="border-t border-(--white-10) mb-3!" />
                <div className="flex items-center justify-between py-2!">
                  <div className="flex flex-col">
                    <div className="flex items-center gap-2">
                      <span className="font-medium">Suggested split</span>
                      <span className="text-xs px-2! py-0.5! rounded-full bg-(--white-10) text-(--white-70)">
                        Default
                      </span>
                    </div>
                    <span className="text-xs text-(--white-60)">
                      Members choose when to add workouts to their calendar.
                    </span>
                  </div>
                  <div className="labeled-switch bg-transparent!" sz="large">
                    <input
                      type="checkbox"
                      id="switch-suggested-split"
                      role="switch"
                      checked={trainingSplitType === "suggested"}
                      onChange={() => {
                        if (trainingSplitType === "suggested") return;
                        if (
                          editCycle &&
                          !window.confirm(
                            "Changing this setting will affect future weeks. Continue?"
                          )
                        )
                          return;
                        this.setState({ trainingSplitType: "suggested" });
                      }}
                    />
                  </div>
                </div>
                <div className="border-t border-(--white-10)" />
                <div className="flex items-center justify-between py-2!">
                  <div className="flex flex-col">
                    <span className="font-medium">Forced training split</span>
                    <span className="text-xs text-(--white-60)">
                      Workouts are added only on the coach-prescribed dates. Members cannot reschedule.
                    </span>
                  </div>
                  <div className="labeled-switch bg-transparent!" sz="large">
                    <input
                      type="checkbox"
                      id="switch-training-split"
                      role="switch"
                      checked={trainingSplitType === "forced"}
                      onChange={() => {
                        if (trainingSplitType === "forced") return;
                        if (
                          editCycle &&
                          !window.confirm(
                            "Changing this setting will affect future weeks. Continue?"
                          )
                        )
                          return;
                        this.setState({ trainingSplitType: "forced" });
                      }}
                    />
                  </div>
                </div>
                {canHideFromPush && (
                  <>
                    <div className="border-t border-(--white-10)" />
                    <input
                      type="hidden"
                      name="hideFromPush"
                      value={hideFromPush ? "true" : "false"}
                    />
                    <div className="flex items-center justify-between py-2!">
                      <div className="flex flex-col">
                        <div className="flex items-center gap-2">
                          <span className="font-medium">
                            {t("addCycle.hideFromPush.label")}
                          </span>
                          <ToolTip
                            body={t("addCycle.hideFromPush.tooltip")}
                            id="team-hide-from-push-info"
                          >
                            <SvgIcon
                              alt={t("addCycle.infoIconAlt")}
                              src="/img/new-icons/question-circle.svg"
                            />
                          </ToolTip>
                        </div>
                        <span className="text-xs text-(--white-60)">
                          {t("addCycle.hideFromPush.description")}
                        </span>
                      </div>
                      <div
                        className="labeled-switch bg-transparent!"
                        sz="large"
                      >
                        <input
                          type="checkbox"
                          id="switch-hide-from-push"
                          role="switch"
                          aria-checked={hideFromPush}
                          checked={hideFromPush}
                          disabled={(!!editCycle && editCycle?.status === "published")}
                          onChange={() => {
                            const next = !hideFromPush;
                            if (
                              next &&
                              typeof window !== "undefined" &&
                              !window.confirm(
                                t("addCycle.hideFromPush.confirm")
                              )
                            ) {
                              return;
                            }
                            this.setState({ hideFromPush: next });
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>

          <footer>
            <button
              type="button"
              data-button-type="secondary"
              data-action="cancel"
              onClick={() => {
                submit("/actions/refresh", {
                  method: "GET",
                  body: { modal: "" },
                });
              }}
            >
              {t("common:cancel")}
            </button>
            <button
              type="submit"
              className="button save"
              data-button-type="primary"
            >
              {t("common:save")}
            </button>
          </footer>
        </Modal>
      </form>
    );
  }
}

const ExperienceLevel = ({ setState, experience, t }) => {
  return (
    <div className="group">
      <label>{t("addCycle.experienceLevel")}</label>
      <div className="gradient-range">
        <input
          type="range"
          min={1}
          max={3}
          step={1}
          value={experience || 2}
          id="experience"
          name="difficulty"
          style={{
            background: `linear-gradient(to right, var(--gradient-left) 0%, var(--gradient-right) ${
              experience === 1 ? "0" : experience === 2 ? "50" : "100"
            }%, var(--white-10) ${
              experience === 1 ? "0" : experience === 2 ? "50" : "100"
            }%)`,
          }}
          onChange={({ target: { value } }) => {
            setState({
              experience: parseInt(value),
            });
          }}
        />
        <div className="slider-label">
          <span>{t("addCycle.beginner")}</span>
          <span>{t("addCycle.expert")}</span>
        </div>
      </div>
    </div>
  );
};

AddCycleModal.contextType = RillContext;

export default withTranslation("coaching-portal")(AddCycleModal);
